import React from 'react';
import i18n from 'i18next';

export default function LoginDisclaimer() {
  return (
    <div className="text-white text-center pt-8">
      {/* First line */}
      {i18n.t('loginPage.siteDescription')}
      <br />
      {/* Second line */}
      {i18n.t('loginPage.link.prefix')}{' '}
      <a
        href="mailto:info@wisbits.nl"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        {i18n.t('loginPage.link.linkLabel')}
      </a>{' '}
      {i18n.t('loginPage.link.suffix')}
      <br style={{marginTop: 10}} />
      {/* Third line */}
      {
        <a
          href="https://www.wisbits.nl/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline block mt-4"
        >
          {i18n.t('common.privacy-policy')}
        </a>
      }
    </div>
  );
}
